<!--
  Se pinta siempre, también en Normal, por lo mismo que la píldora de cartera dice «Sin asignar»:
  un control que solo aparece cuando ya está puesto no se puede poner la primera vez.
-->
<button
  type="button"
  class="sit-pill"
  [ngClass]="tono"
  *ngIf="puedeCambiar; else sitEstatica"
  [pTooltip]="
    esNormal ? 'Marcar el arrendamiento en juicio, en reestructuración o como cartera vencida' : 'Cambiar la situación del arrendamiento'
  "
  tooltipPosition="top"
  (click)="abrir()"
>
  <i class="fa-solid fa-gavel" *ngIf="actual === 'EN_JUICIO'"></i>
  <i class="fa-solid fa-file-signature" *ngIf="actual === 'REESTRUCTURACION'"></i>
  <i class="fa-solid fa-ban" *ngIf="actual === 'CARTERA_VENCIDA'"></i>
  <i class="fa-solid fa-circle-check" *ngIf="esNormal"></i>
  <span class="sit-pill__label">Situación</span>
  <span class="sit-pill__value">{{ etiqueta }}</span>
  <i class="fa-solid fa-pencil sit-pill__edit" aria-hidden="true"></i>
</button>

<ng-template #sitEstatica>
  <!-- Sin permiso, o cancelado: se lee igual, sin lápiz. Normal no se enseña — sería ruido en todos. -->
  <span class="sit-pill is-static" [ngClass]="tono" *ngIf="!esNormal">
    <i class="fa-solid fa-gavel" *ngIf="actual === 'EN_JUICIO'"></i>
    <i class="fa-solid fa-file-signature" *ngIf="actual === 'REESTRUCTURACION'"></i>
    <i class="fa-solid fa-ban" *ngIf="actual === 'CARTERA_VENCIDA'"></i>
    <span class="sit-pill__label">Situación</span>
    <span class="sit-pill__value">{{ etiqueta }}</span>
  </span>
</ng-template>

<!-- Derivada, no capturada: la deja la terminación anticipada del editor de saldos. -->
<span
  class="sit-pill is-static is-muted"
  *ngIf="terminacionAnticipada"
  pTooltip="Se liquidó por terminación anticipada (editor de saldos)"
  tooltipPosition="top"
>
  <i class="fa-solid fa-flag-checkered"></i>
  <span class="sit-pill__label">Estatus</span>
  <span class="sit-pill__value">Terminación anticipada</span>
</span>

<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="!guardando"
  header="Situación del arrendamiento"
  styleClass="sit-dialog"
  [style]="{ width: '520px' }"
>
  <div class="sit-form">
    <div class="sit-opt" *ngFor="let o of opciones" [class.is-sel]="seleccion === o.value" (click)="seleccion = o.value">
      <p-radioButton [value]="o.value" [(ngModel)]="seleccion" [inputId]="'sit-' + o.value" name="sit"></p-radioButton>
      <label [for]="'sit-' + o.value">
        <b>{{ o.label }}</b>
        <span>{{ o.help }}</span>
      </label>
    </div>

    <!--
      Obligatorio, y el backend también lo exige. Sacar un arrendamiento de la cartera baja el total
      del mes: sin el motivo escrito, medio año después nadie puede explicar por qué esa cifra cambió.
    -->
    <label class="sit-label" for="sit-motivo">Motivo del cambio</label>
    <textarea id="sit-motivo" pInputTextarea [(ngModel)]="motivo" rows="2" placeholder="Queda en el historial del arrendamiento"></textarea>
    <small class="sit-hint" *ngIf="motivo && !motivoSuficiente">Escríbelo con algo más de detalle — queda en el historial.</small>

    <small class="sit-err" *ngIf="error">{{ error }}</small>
  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancelar" class="p-button-text" [disabled]="guardando" (click)="visible = false"></button>
    <button
      pButton
      type="button"
      label="Guardar"
      icon="fa-solid fa-check"
      [loading]="guardando"
      [disabled]="!puedeGuardar"
      (click)="guardar()"
    ></button>
  </ng-template>
</p-dialog>
